import { render, staticRenderFns } from "./AuditLogsList.vue?vue&type=template&id=cf9ca87a&scoped=true"
import script from "./AuditLogsList.vue?vue&type=script&lang=js"
export * from "./AuditLogsList.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsList.vue?vue&type=style&index=0&id=cf9ca87a&prod&lang=scss"
import style1 from "./AuditLogsList.vue?vue&type=style&index=1&id=cf9ca87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ca87a",
  null
  
)

export default component.exports